import React from 'react';
import { Box, Typography } from '@saviynt/design-system';
import { useHistory } from 'react-router-dom';

import { useInvertedLocalize } from '../../../../utils';
import { providers } from '../../data-layer/constants';
import { type ProviderResponse } from '../../data-layer/types';
import ProviderCard from '../common/ProviderCard/ProviderCard';

import invertedMessages from './messages';

import './SetUpIdProofing.css';

function SetUpIdProofing() {
  const l = useInvertedLocalize(invertedMessages);
  const history = useHistory();

  const handleSetupBtn = (item: ProviderResponse) => {
    history.push({
      pathname: `/providers/settings`,
      search: `?id=${item.vendorName}`,
    });
  };

  return (
    <Box className='Ext-SetUpIdProofing'>
      <Typography
        kind='display2'
        color='--color-foreground-secondary-bold'
        className='Ext-SetUpIdProofing-title'>
        {l('Set Up Identity Verification Today to Boost Security')}
      </Typography>
      <Box className='Ext-SetUpIdProofing-chooseProvider'>
        <Typography kind='h2' color='--color-foreground-neutral-bold'>
          {l('Choose a provider')}
        </Typography>
      </Box>
      <div className='Ext-SetUpIdProofing-providers'>
        {providers.map((item) => (
          <ProviderCard
            provider={providers.find((prov) => prov.id === item.vendorName)}
            item={item}
            handleConfigureClick={handleSetupBtn}
            setErrorMessage={() => {}}
            setShowCriticalBanner={() => {}}
            setAlertTitle={() => {}}
            setAlertStatus={() => {}}
            refetchIDPProviders={() => {}}
            setIsEnableSuccessVisible={() => {}}
          />
        ))}
      </div>
    </Box>
  );
}

export default SetUpIdProofing;
